import { render, staticRenderFns } from "./ProfessionCategoryCreateForm.vue?vue&type=template&id=1588d53a&"
import script from "./ProfessionCategoryCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProfessionCategoryCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports